import { AsyncButton, type AsyncButtonClick } from "./Button.js";
import { closeEventDialog } from "./Dialogs.js";

/**
 * Set of yes/no buttons that allow you to confirm an action.
 * - Clicking `Yes` calls `onConfirm`
 * - Clicking `No` calls the current cancel context.
 */
export function Confirm({ onConfirm }: { onConfirm: AsyncButtonClick }) {
	return (
		<div className="flex-row space-xsmall gap-xsmall">
			<button type="button" className="button" onClick={closeEventDialog}>
				No
			</button>
			<AsyncButton mods="button-confirm" onClick={onConfirm}>
				Yes
			</AsyncButton>
		</div>
	);
}
